import { render, staticRenderFns } from "./AncillaryReissueSearchLegBodyCard.vue?vue&type=template&id=27f2f93c&scoped=true"
import script from "./AncillaryReissueSearchLegBodyCard.vue?vue&type=script&lang=js"
export * from "./AncillaryReissueSearchLegBodyCard.vue?vue&type=script&lang=js"
import style0 from "./AncillaryReissueSearchLegBodyCard.vue?vue&type=style&index=0&id=27f2f93c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f2f93c",
  null
  
)

export default component.exports